import Debug from 'debug'
import { injectable, inject } from 'inversify';
import { Location } from 'vue-router';
import { AspectService, AspectServiceSymbol } from '@/app/aspect/aspect-service';
import { TrackingService2, TrackingService2Symbol } from '@/app/tracking/api'
import { createPageLocation } from '@/app/shared/utils/route-utils';
import { queryBookmarkItem} from '@/app/shared/utils/bookmark-utils';

//import { QuizBankService, QuizBankServiceSymbol } from '@/app/quiz/services/quiz-bank-service';
//import { QuestionBankService, QuestionBankServiceSymbol } from '@/app/question/question-bank-service';
import { CompetenceService, CompetenceServiceSymbol } from '@/app/competence/competence-service';
// import { Quiz } from '@/app/shared/models';
// import { dispatchObjectCompletedEvent } from '@/app/statistics/utils/object-completion-utils';
//import { calculateQuestionsPercentAndSetToStore } from '@/app/question/question-utils';
import aspectStoreModule from '@/app/aspect/apsect-state';
//import questionProgressStoreModule from '@/app/question/state/question-progress-state';
// import { ExamResultsQuery, ExamResultsQuerySymbol } from '@/app/exam';
// import * as QuestionTrackingApi from '@/app/question/tracking/api'
import { getTocItemBySectionId } from '@/app/aspect/toc-utils';


const debug = Debug('layout-service')

@injectable()
export class LayoutService {
  @inject(AspectServiceSymbol)
  private aspectService: AspectService;

  @inject(TrackingService2Symbol)
  private trackingService: TrackingService2

  // @inject(QuizBankServiceSymbol)
  // private quizBankService: QuizBankService;

  // @inject(QuestionBankServiceSymbol)
  // private questionBankService: QuestionBankService;

  @inject(CompetenceServiceSymbol)
  private competenceService: CompetenceService;

  // @inject(ExamResultsQuerySymbol)
  // private examResultsQuery: ExamResultsQuery

  private state: 'none' | 'initialized'

  constructor() {
    debug('LayoutService constructor')

    this.state = 'none'
  }

  public async init(): Promise<void> {

    debug('init')
    this.aspectService.init()
    
    debug('aspectStoreModule.aspects', aspectStoreModule.aspects)
    if (aspectStoreModule.aspects === null) {
      await this.aspectService.loadAspectsToStore();
      debug('aspectStoreModule.aspects after load', aspectStoreModule.aspects)
    }

    debug('setting selected aspect', aspectStoreModule.selectedAspectInstanceId)
    await this.aspectService.set(aspectStoreModule.selectedAspectInstanceId, true);

    // await this.loadQuizCompletions();
    // await this.loadQuestionCompletions();
    // calculateQuestionsPercentAndSetToStore();

    this.competenceService.calculateAndSetToStore();

    this.state = 'initialized'
  }

  public async resolveToStartingPageLocation(): Promise<Location> {

    debug('resolveToStartingPageLocation')

    if (this.state !== 'initialized') {
      throw new Error('LayoutService not yet initialized')
    }

    const selectedAspectInstance = aspectStoreModule.selectedCourseAspectInstance
    debug('selectedAspectInstance', selectedAspectInstance)
    const bookmarkItem =  await queryBookmarkItem(this.trackingService);
    debug(`is skip dashboard enabled: ${selectedAspectInstance ? selectedAspectInstance.skipDashboard : 'no aspect'}`)
    if (selectedAspectInstance && selectedAspectInstance.skipDashboard) {
      debug('bookmarkItem', bookmarkItem)

      let targetPage = null

      if (bookmarkItem) {
        // it is a valid bookmark item
        targetPage = bookmarkItem
      } else {
        // we have no valid bookmark, use the first page
        // REVIEW: it's kind of hack, but I now use the predefined API
        const firstPageHref = this.aspectService.getFirstPageId()
        if (firstPageHref) {
          const firstSection = this.aspectService.calculateSectionByPage(firstPageHref)
          debug('firstPageHref,firstPageSection', firstPageHref, firstSection)
          if (firstSection) {
            targetPage = getTocItemBySectionId(firstSection.id)
            debug('page for first page', targetPage)
          }
        }
      }

      if (targetPage) {
        const location = createPageLocation(targetPage.href, targetPage.sectionId, targetPage.isChild)
        debug('resolved starting location', location)
        return location
      }
    }

    debug('using dashboard as starting location')
    return { name: 'dashboard'}
  }

  // REVIEW: why dispatch events in loading?
  // private async loadQuizCompletions(): Promise<void> {
  //   const quizIds = this.quizBankService.allQuizIds();
  //   const allQuestionsByQuizId: { [id: string]: string[] } = this.queryQuizQuestionIdsAndSetToStore(quizIds);

  //   // TODO: it is not reactive
  //   const results = this.examResultsQuery.examResults
  //   // const results = await this.quizResultsService.queryExamState(quizIds);
  //   // if (results === null) {
  //   //   return;
  //   // }

  //   const completedIds = results.map(x => x.id)

  //   completedIds.forEach((id) => {
  //     const questionIds: string[] = allQuestionsByQuizId[id];
  //     this.setCompletedQuestionIdsToStore(questionIds);
  //   });
  // }

  // private queryQuizQuestionIdsAndSetToStore(quizIds: string[]): { [id: string]: string[] } {
  //   const allQuestionsByQuizId: { [id: string]: string[] } = {};
  //   quizIds.forEach((id) => {
  //     const quiz: Quiz = this.quizBankService.find(id);
  //     if (quiz.allowedModes.length > 0) {
  //       // TODO: which mode to use?
  //       const mode = quiz.allowedModes[0];
  //       const questionIds = quiz.questions[mode].map((q) => q.questionId);
  //       allQuestionsByQuizId[id] = questionIds;
  //       this.setQuestionIdsToStore(questionIds);
  //     }
  //   });

  //   return allQuestionsByQuizId;
  // }

  // private async loadQuestionCompletions(): Promise<void> {
  //   const questionIds = this.questionBankService.allQuestionIds();
  //   this.setQuestionIdsToStore(questionIds);

  //   const query = createQuery<QuestionTrackingApi.QueryQuestionsTrackingQuery>('query-questions',
  //                                                                              { ids: questionIds})
  //   const questionsResult = await this.trackingService.query(query)

  //   const completedIds: string[] = this.dispatchQuestionCompletedEvents(
  //     questionsResult.questions,
  //     (item) => item.attempts.length > 0
  //   );
  //   this.setCompletedQuestionIdsToStore(completedIds);
  // }

  // private dispatchQuizCompletedEvents(
  //   results: ExamState[],
  //   isCompletedCallback: (item: ExamStateDetails) => boolean
  // ): string[] {
  //   let completedIds: string[] = [];
  //   results.forEach((item) => {
  //     if (isCompletedCallback(item.details)) {
  //       completedIds = [...completedIds, item.id];
  //       dispatchObjectCompletedEvent(item.id);
  //     }
  //   });

  //   return completedIds;
  // }

  // private dispatchQuestionCompletedEvents(
  //   results: QuestionTrackingApi.QuestionState[],
  //   isCompletedCallback: (item: QuestionTrackingApi.QuestionState) => boolean
  // ): string[] {
  //   let completedIds: string[] = [];
  //   results.forEach((item) => {
  //     if (isCompletedCallback(item)) {
  //       completedIds = [...completedIds, item.id];
  //       dispatchObjectCompletedEvent(item.id);
  //     }
  //   });

  //   return completedIds;
  // }

  // private setQuestionIdsToStore(questionIds: string[]): void {
  //   questionIds.forEach((id) => {
  //     questionProgressStoreModule.addToAllQuestionIds(id);
  //   });
  // }

  // private setCompletedQuestionIdsToStore(questionIds: string[]): void {
  //   if (!questionIds) {
  //     return;
  //   }

  //   questionIds.forEach((id) => {
  //     questionProgressStoreModule.addToCompletedQuestionIds(id);
  //   });
  // }
}

export const LayoutServiceSymbol = Symbol.for('LayoutService');
